import {
  SWITCH_PAGE,
  SAVE_TRANSACTION_HISTORY,
  SAVE_SESSION_ID,
  SAVE_ACCOUNT_PROVIDERS,
} from '../actions'

const INIT_STATE = {
  currentScreen: 'dashboard',
  transactionHistory: [],
  sessionId: '',
  accountBalance: 10000000,
  accountProviders: [],
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_SESSION_ID:
      return { ...state, sessionId: action.payload }
    case SWITCH_PAGE:
      return { ...state, currentScreen: action.payload }
    case SAVE_TRANSACTION_HISTORY:
      const currentBalance = state.accountBalance - action.payload.amount
      return {
        ...state,
        accountBalance: currentBalance,
        transactionHistory: [...state.transactionHistory, action.payload],
      }
    case SAVE_ACCOUNT_PROVIDERS:
      return {
        ...state,
        accountProviders: action.payload,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/InternetBankingSimulatorApp/reducers/index.js